import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import '@design-tokens';
import './styles/app.css';

const el = document.getElementById('root');
if (!el) throw new Error('Élément #root introuvable dans index.html');

createRoot(el).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
